import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Dashboard } from './pages/Dashboard';
import { Performance } from './pages/Performance';
import { Sites } from './pages/Sites';
import { SiteDetail } from './pages/SiteDetail';
import { EdgePage } from './pages/EdgePage';
import { Chat } from './pages/Chat';
import { Login } from './pages/Login';
import { Projects } from './pages/Projects';
import { Project } from './pages/Project';
import { ProjectRepo } from './pages/ProjectRepo';
import { PhonePage } from './pages/PhonePage';
import { Settings } from './pages/Settings';
import { Shell } from './pages/Shell';
import { TerminalPage } from './pages/TerminalPage';

export function App() {
  const { state } = useAuth();

  if (state === 'loading') {
    return (
      <div className="flex h-full items-center justify-center text-neutral-500">
        <span className="animate-pulse text-sm">betöltés…</span>
      </div>
    );
  }

  if (state === 'anon') return <Login />;

  // Aktivált felhasználó — a teljes alkalmazás.
  return (
    <Routes>
      <Route path="phone" element={<PhonePage />} />
      <Route element={<Shell />}>
        <Route index element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:id" element={<Project />} />
        <Route path="projects/:id/repo" element={<ProjectRepo />} />
        <Route path="terminal" element={<TerminalPage />} />
        <Route path="performance" element={<Performance />} />
        <Route path="sites" element={<Sites />} />
        <Route path="sites/edge" element={<EdgePage />} />
        <Route path="sites/:id" element={<SiteDetail />} />
        <Route path="chat" element={<Chat />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
